import {
  USER_LIST_START,
  USER_LIST_SUCCESS,
  USER_LIST_FAIL,
  USER_INVITE_START,
  USER_INVITE_SUCCESS,
  USER_INVITE_FAIL,
  USER_BY_ID_START,
  USER_BY_ID_SUCCESS,
  USER_BY_ID_FAIL,
  DEACTIVATE_USER_START,
  DEACTIVATE_USER_SUCCESS,
  DEACTIVATE_USER_FAIL,
  ACTIVATE_USER_START,
  ACTIVATE_USER_SUCCESS,
  ACTIVATE_USER_FAIL,
  UPLOAD_USER_LOGO_START,
  UPLOAD_USER_LOGO_SUCCESS,
  UPLOAD_USER_LOGO_FAIL,
  USER_LOGIN_START,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAIL,
  USER_CONFIRM_REST_PASS_START,
  USER_CONFIRM_REST_PASS_SUCCESS,
  USER_CONFIRM_REST_PASS_FAIL,
  USER_CONFIRM_REGISTRATION_START,
  USER_CONFIRM_REGISTRATION_SUCCESS,
  USER_CONFIRM_REGISTRATION_FAIL
} from './constants';

export const userListReducer = (
  state = {
    users: {},
    fetching: false,
    error: null,
    test: false
  },
  action
) => {
  switch (action.type) {
    case USER_LIST_START:
    case DEACTIVATE_USER_START:
    case ACTIVATE_USER_START:
      return { ...state, fetching: true };
    case USER_LIST_SUCCESS:
      return { ...state, fetching: false, users: action.payload };
    case USER_LIST_FAIL:
      return { ...state, fetching: false, error: action.payload };
    case DEACTIVATE_USER_SUCCESS:
      return {
        ...state,
        fetching: false,
        users: {
          ...state.users,
          items: [
            ...state.users.items.map((item) => {
              if (item.id === action.id) {
                return {
                  ...item,
                  status: 'Заблокирован'
                };
              }
              return item;
            })
          ]
        }
      };
    case DEACTIVATE_USER_FAIL:
      return { ...state, fetching: false, error: action.payload || null };
    case ACTIVATE_USER_SUCCESS:
      return {
        ...state,
        fetching: false,
        users: {
          ...state.users,
          items: [
            ...state.users.items.map((item) => {
              if (item.id === action.id) {
                return {
                  ...item,
                  status: 'Активен'
                };
              }
              return item;
            })
          ]
        }
      };
    case ACTIVATE_USER_FAIL:
      return { ...state, fetching: false, error: action.payload || null };
    default:
      return state;
  }
};

export const inviteUserReducer = (
  state = {
    status: null,
    fetching: false,
    error: null
  },
  action
) => {
  switch (action.type) {
    case USER_INVITE_START:
      return { ...state, fetching: true };
    case USER_INVITE_SUCCESS:
      return { ...state, fetching: false, status: action.payload.status, message: null };
    case USER_INVITE_FAIL:
      return { ...state, fetching: false, status: 400, message: action.payload?.detail };
    default:
      return state;
  }
};

export const userByIdReducer = (
  state = {
    info: {},
    fetching: false,
    error: null
  },
  action
) => {
  switch (action.type) {
    case USER_BY_ID_START:
    case ACTIVATE_USER_START:
    case DEACTIVATE_USER_START:
    case UPLOAD_USER_LOGO_START:
      return { ...state, fetching: true };
    case USER_BY_ID_SUCCESS:
      return { ...state, fetching: false, info: action.payload };
    case USER_BY_ID_FAIL:
      return { ...state, fetching: false, error: action.payload };
    case DEACTIVATE_USER_SUCCESS:
      return { ...state, fetching: false, info: { ...state.info, status: 'Заблокирован' } };
    case DEACTIVATE_USER_FAIL:
      return { ...state, fetching: false, error: action.payload || null };
    case ACTIVATE_USER_SUCCESS:
      return { ...state, fetching: false, info: { ...state.info, status: 'Активен' } };
    case ACTIVATE_USER_FAIL:
      return { ...state, fetching: false, error: action.payload || null };
    case UPLOAD_USER_LOGO_SUCCESS:
      return { ...state, fetching: false };
    case UPLOAD_USER_LOGO_FAIL:
      return { ...state, fetching: false, error: action.payload || null };
    default:
      return state;
  }
};

export const currentUserReducer = (
  state = {
    userData: {},
    fetching: false,
    isAuth: false
  },
  action
) => {
  switch (action.type) {
    case USER_LOGIN_START:
      return { ...state, fetching: true, isAuth: false };
    case USER_LOGIN_SUCCESS:
      return { ...state, fetching: false, isAuth: true, userData: action.payload };
    case USER_LOGIN_FAIL:
      return { ...state, fetching: false, isAuth: false, error: action.payload };
    case USER_CONFIRM_REST_PASS_START:
      return { ...state, fetching: true };
    case USER_CONFIRM_REST_PASS_SUCCESS:
      return { ...state, fetching: false, userData: action.payload };
    case USER_CONFIRM_REST_PASS_FAIL:
      return { ...state, fetching: false, error: action.payload };
    case USER_CONFIRM_REGISTRATION_START:
      return { ...state, fetching: true };
    case USER_CONFIRM_REGISTRATION_SUCCESS:
      return { ...state, fetching: false, userData: action.payload };
    case USER_CONFIRM_REGISTRATION_FAIL:
      return { ...state, fetching: false, error: action.payload };
    default:
      return state;
  }
};
